import React from 'react';
import {useSelector} from "react-redux";
import classnames from 'classnames';

export default function StatusTextBar() {
  const text = useSelector(state => state.footer.statusText);
  const show = useSelector(state => state.footer.show);

  return <div className={classnames({'status-text-bar': 1, 'hidden': !show})}>{text}</div>
}
